<template>
	<div v-if="$screen.width <= 992" class="animated fadeIn pr-1 pl-1">
		<div class="container-mobile">
			<div class="my-expense-mobile">
				<div v-if="poItems.length > 0" class="my-expense-status-actions p-1">
					<div class="check-actions cursor-pointer" @click="setSelectionForAll(purchaseOrder, poIndex, checkAll)">
						<div class="d-flex text-left" v-if="purchaseOrder.isSelectedAll">
							{{ FormMSG(2, 'None') }}&nbsp;
							<component :is="getLucideIcon('Square')" :size="16" />
						</div>
						<div class="d-flex" v-else>
							{{ FormMSG(1, 'All') }} &nbsp;
							<component :is="getLucideIcon('CheckSquare')" :size="16" />
						</div>
					</div>
				</div>
				<div class="content pb-3" v-if="poItems.length > 0">
					<div class="card-expense" v-for="poItem in poItems" :key="poItem.id">
						<div class="wrapper">
							<div class="resume">
								<div class="first-col">
									<b-form-checkbox
										v-if="+poItem.amountTotal !== 0"
										size="lg"
										v-model="poItem.selectState"
										@change="updateSelectedRows(purchaseOrder, poIndex, poItem)"
									/>
								</div>
								<div class="second-col" :style="`width: ${notSubmittedState && parseInt(poItem.validated, 10) === 0 ? '56.5%;' : '67.5%;'}`">
									<div class="description">
										{{ poItem.description }}
									</div>
									<div class="title">#{{ poItem.id }}</div>
									<div>
										{{ FormMSG(6, 'Net') }} : <span class="amount">{{ displayCurrency(poItem.priceTotal) }}</span>
									</div>
									<div>
										{{ FormMSG(7, 'Tax') }} : <span class="amount">{{ displayCurrency(poItem.priceVatTotal) }}</span>
									</div>
									<div>
										{{ FormMSG(5, 'Initial Amount') }} : <span class="amount">{{ displayCurrency(poItem.total) }}</span>
									</div>
									<div>
										{{ FormMSG(4, 'Remaining Amount') }} : <span class="amount">{{ displayCurrency(poItem.remainingAmount) }}</span>
									</div>
								</div>
								<div class="third-col">
									<div class="status-wrapper">
										<div>{{ poItem.categoryCostCenter }}-{{ poItem.categoryName }}</div>
									</div>
								</div>
							</div>
							<b-row class="actions pt-2">
								<b-col cols="1"> </b-col>
								<b-col cols="11">
									<div>
										<v-select
											class="w-100 absolute grow-flex-auto"
											v-model="poItem.action"
											:placeholder="FormMSG(11, 'choose...')"
											label="text"
											:options="getActionsMenu"
											:appendToBody="true"
											:reduce="(option) => option.value"
											@input="handleChangeAction(poItem)"
										></v-select>
									</div>
								</b-col>
							</b-row>
						</div>
					</div>
				</div>
				<div v-else class="empty-data pb-3">
					{{ FormMSG(3, 'No Po found') }}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import mapProps from '@/shared/vuePropsMapper';
import moment from 'moment';
import { rendCurrency } from '~helpers';
import invoicesTools from '@/mixins/invoicesTools.mixin';

export default {
	name: 'PoTransactionDataMobile',
	mixins: [languageMessages, globalMixin, invoicesTools],
	props: {
		poItemLists: Array,
		purchaseOrder: Object,
		poIndex: Number,
		notSubmittedState: Boolean,
		allSelected: Boolean,
		selectedDataRows: Array,
		submittedState: Boolean,
		...mapProps(['forApprove', 'forDraft', 'forPending', 'forApproved'], {
			type: Boolean,
			default: false
		})
	},
	data() {
		return {
			checkAll: false,
			selectedRows: [],
			poItems: []
		};
	},
	methods: {
		setSelectionForAll(po, poIndex, event) {
			this.checkAll = !event;
			this.$emit('setSelectionForAll', po, poIndex, this.checkAll);
		},
		updateSelectedRows(poItem, poIndex, selectedItem) {
			this.$emit('updateSelectedRows', poItem, poIndex, selectedItem);
		},
		dateToLiteral(invoiceDate) {
			const langCurrent = this.currentLang;
			const fullLiteralDate = moment(invoiceDate).locale(`${langCurrent}`).format(`dddd, Do MMMM YYYY`);

			return fullLiteralDate;
		},
		displayCurrency(value) {
			return rendCurrency(value);
		},
		handleChangeAction(poItem) {
			this.$emit('handleChangeAction', poItem);
		}
	},
	computed: {
		check() {
			return this.$store.getters.distanceUnit;
		}
	},
	watch: {
		poItemLists: {
			handler(newVal) {
				this.poItems = newVal;
			},
			immediate: true,
			deep: true
		}
	}
};
</script>
